module.exports = __webpack_public_path__ + "img/azstudio.7b78f1e5.png";